import React from 'react'
import { signIn } from 'firebase/functions'
import withStatus from 'hocs/bases/withStatus'
import LoginForm from 'components/login/LoginForm'
import glamorous from 'glamorous'

const styles = {
  columns: {
    display: 'flex',
    height: '100vh',
  },
  column: {
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '2rem',
  },
  quote: {
    position: 'absolute',
    bottom: 50,
    fontSize: '1rem',
    color: '#e8e8e8',
    width: '60%',
    fontStyle: 'italic',
    textAlign: 'center',
  },
  logo: {
    minWidth: 250,
    maxWidth: 300,
  },
}

const Title = glamorous.h1({
    fontSize: '2.2rem',
    marginTop: '2.5rem',
  },
  ({ font }) => ({
    fontFamily: font.family.length ? font.family[0].value: '',
    color: font.color,
  })
)

const LeftColumn = glamorous.div(
  {
    ...styles.column,
    backgroundSize: 'cover',
    boxShadow: `0 0 14px 7px rgba(0, 0, 0, 0.32)`,
    position: 'relative',
  },
  ({ background: { color, image } }) => ({
    backgroundColor: color,
    backgroundImage: image ? `url(${image})` : '',
  })
)

const RightColumn = glamorous.div({
  ...styles.column,
  backgroundColor: '#e8e8e8',
})

const LoginPage = withStatus({
  actionName: 'onSignIn',
  statusName: 'signInStatus',
  getAction: () => signIn,
  getRequestMessage: () => 'Authenticating your account.',
})(({
  onSignIn,
  signInStatus: {
    errorMessage,
    message,
  },
  preferences: {
    logo,
    font,
    background,
  },
}) => (
  <div style={styles.columns}>
    <LeftColumn background={background}>
      <img
        src={logo}
        alt="logo"
        style={styles.logo}
      />
      <Title font={font}>Content Management System</Title>
      <p style={{ ...styles.quote, color: font.color }}>
        "Content is the emotional and informational bridge between commerce and consumer"<br/>(Jay Baer)
      </p>
    </LeftColumn>
    <RightColumn>
      <LoginForm
        onSignIn={onSignIn}
        isSigningInMessage={message}
        errorMessage={errorMessage}
      />
    </RightColumn>
  </div>
))

export default LoginPage


// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js